import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'flex',
      marginBottom: Spacings.s24,
    },
    logo: {
      marginRight: Spacings.s24,
      width: 72,
      height: 72,
      borderRadius: '50%',

      [mediaQuery(1023)]: {
        marginRight: Spacings.s16,
        width: 48,
        height: 48,
      },
    },
    picture: {
      borderRadius: '50%',
    },
    textHolder: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    title: {
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s36,
      color: TextColors.base,

      [mediaQuery(1023)]: {
        fontSize: FontSizes.s24,
      },
    },
    desc: {
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s20,
      color: TextColors.base,

      [mediaQuery(1023)]: {
        fontSize: FontSizes.s16,
      },
    },
    actionsHolder: {
      display: 'flex',
      order: 3,
      alignSelf: 'center',
      marginLeft: 'auto',
    },
    action: {
      minWidth: 120,
      padding: [FontSizes.s12, FontSizes.s16],
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,

      '&.second': {
        marginRight: Spacings.s12,
      },

      '& > span': {
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
    },
  }),
  {
    name: 'body-text-with-double-cta-title-content',
  },
);

export default useStyles;
